/**
 * Analytics Service - API calls for analytics dashboard
 * 
 * Backend endpoints:
 * GET /api/admin/analytics - Get comprehensive analytics data
 */

import api from './api';

const analyticsService = {
  /**
   * Get analytics data for dashboard
   * @returns {Promise<{success: boolean, data?: object, error?: string}>}
   */
  async getAnalytics() {
    try {
      const response = await api.get('/admin/analytics');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch analytics data'
      };
    }
  },

  /**
   * Get order stats (existing endpoint)
   * @returns {Promise<{success: boolean, data?: object, error?: string}>}
   */
  async getOrderStats() {
    try {
      const response = await api.get('/admin/orders/stats');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch order stats'
      };
    }
  },

  /**
   * Get user stats (existing endpoint)
   * @returns {Promise<{success: boolean, data?: object, error?: string}>}
   */
  async getUserStats() {
    try {
      const response = await api.get('/admin/users/stats');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch user stats'
      };
    }
  }
};

export default analyticsService;